import { type FC, type ReactNode } from 'react';
import { FileText } from 'lucide-react';
import { cn } from '../../lib/utils';

interface LlmDocumentCardLayoutProps {
  title: string;
  type?: string;
  tooltip?: string;
  actions?: ReactNode | null;
  onClick?: (() => any) | null;
  isDeleted?: boolean;
}

/** Renders a card-like layout with a document icon, type, and optional configurable action btns. */
export const LlmDocumentCardLayout: FC<LlmDocumentCardLayoutProps> = ({
  title,
  type,
  tooltip,
  onClick,
  actions,
  isDeleted,
}) => (
  <div
    className={cn(
      'flex flex-row items-center gap-4 p-4 border-1 border-ring rounded-md overflow-hidden text-foreground bg-background',
      isDeleted && 'opacity-60'
    )}
  >
    <div
      className={cn(
        'flex-none',
        !!onClick && !isDeleted && 'cursor-pointer text-devo-blue dark:text-foreground'
      )}
      onClick={!isDeleted ? (onClick ?? undefined) : undefined}
      title={tooltip || title}
    >
      <FileText />
    </div>
    <div className="flex-auto">
      <p>
        <span
          className={cn(
            'font-bold',
            isDeleted && 'line-through',
            !!onClick && !isDeleted && 'text-devo-blue dark:text-foreground cursor-pointer hover:underline'
          )}
          onClick={!isDeleted ? (onClick ?? undefined) : undefined}
          title={tooltip || title}
        >
          {title}
        </span>
        {isDeleted && (
          <span className="ml-2 text-xs font-medium text-destructive/70 bg-destructive/10 px-1.5 py-0.5 rounded">
            deleted
          </span>
        )}
      </p>
      {!!type && <p className="text-sm text-muted-foreground">{type}</p>}
    </div>
    {!!actions && !isDeleted && <div className="flex-none">{actions}</div>}
  </div>
);
